<script setup lang="ts">
import { faCheck, faXmark } from '@fortawesome/pro-solid-svg-icons'
import { markingColorStyle } from '~/utils/markings'

const props = withDefaults(defineProps<{
  color: string
  label: string
  selected?: boolean
  /** Clicking the selected swatch deselects it — hovering shows an X instead of the check. */
  removable?: boolean
}>(), {
  selected: false,
  removable: false,
})

const style = computed(() => markingColorStyle(props.color))
</script>

<template>
  <button
    type="button"
    :aria-label="label"
    :aria-pressed="selected"
    class="group/marking-swatch inline-flex size-5.5 items-center justify-center rounded-full border-2 text-xs leading-none transition-colors duration-150"
    :class="[
      style.buttonClass,
      style.borderColorClass,
      !selected && style.hoverButtonClass,
    ]"
  >
     <span
      v-if="selected"
      class="inline-flex"
      :class="removable && 'group-hover/marking-swatch:hidden'"
      aria-hidden="true"
    >
      <Icon :icon="faCheck" :class="style.iconColorClass" />
    </span>
    <span
      v-if="selected && removable"
      class="hidden group-hover/marking-swatch:inline-flex"
      aria-hidden="true"
    >
      <Icon :icon="faXmark" :class="style.iconColorClass" />
    </span>
  </button>
</template>
